module.exports = __webpack_public_path__ + "img/no-adobe.b5837f6c.png";